/**
 * 文件说明:
 *
 * crm project model
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {createProjectModelWarp} from 'utils/model'
import config from '../config'

export function createProjectModelNamespace(name) {
    return `${config.dvaNamespacePrefix}_${name}`
}

export const createProjectModel = createProjectModelWarp({createProjectModelNamespace})
